<template>
  <div>
    <div class="wrapper">
      <div class="form-compilacao" id="compilacao">       
        <img 
          src="static/imagens/logos/logo_santri.svg" 
          style="width: 15rem; margin-top: 15%" 
          class="w3-margin-bottom">
          <div class="form-alerta" style="font-size: 18px">
            <table v-if="compilacao_adm">
              <tbody>
                <tr>
                  <td>Compilação do ADM:</td>
                  <td class="compilacao">{{compilacao_adm}}</td>
                </tr>
                <tr>
                  <td>Compilação do ADMWeb:</td>
                  <td v-if="compilacao_adm == compilacao_adm_web" class="compilacao">{{compilacao_adm_web}}</td>
                  <td v-if="compilacao_adm != compilacao_adm_web" class="compilacao-divergente">{{compilacao_adm_web}}</td>
                </tr>
                <tr>
                  <td>Compilação do diretório dist:</td>
                  <td v-if="compilacao_adm == compilacao_diretorio_dist" class="compilacao">{{compilacao_diretorio_dist}}</td>
                  <td v-if="compilacao_adm != compilacao_diretorio_dist" class="compilacao-divergente">{{compilacao_diretorio_dist}}</td>
                </tr>
              </tbody>
            </table>

            <div v-if="existe_diferenca_compilacao" style="margin-top: 15px; margin-bottom: 15px;">
              <strong class="texto-vermelho fa-blink">Compilações com divergência!</strong>
            </div>
          </div>
      </div>   
    </div>  
  </div>
</template>

<script>
  import store from '@/ambiente/store';
  import RSessao from '@/components/Rest/RSessao.js'

  export default {
    name: 'Compilacao',
    data () {
      return {
        compilacao_adm: '',
        compilacao_adm_web: '',
        compilacao_diretorio_dist: '',
        existe_diferenca_compilacao: false,
      }
    },

    async created() {
      try {
        await RSessao.buscarDadosCarregarSessao(this.axios);
       
        this.compilacao_adm = store.state.parametros_gerais.compilacao_adm;
        this.compilacao_adm_web = store.state.parametros_gerais.compilacao_adm_web;
        this.compilacao_diretorio_dist = await buscarCompilacaoDist();

        this.existe_diferenca_compilacao = false;
        if 
          (
            (this.compilacao_adm != this.compilacao_adm_web) ||
            (this.compilacao_adm != this.compilacao_diretorio_dist) 
          )
        {
          this.existe_diferenca_compilacao = true;
        }

      }
      catch (data) {
        console.log('Erro ao requisitar as compilações: ' + JSON.stringify(data));
      }
    }
  }
</script>

<style scoped>
  .form-signin {
    width: 360px;
    padding: 8% 0 0;
    margin: auto;
    text-align: left;
    max-width: 95%;
  }

  .form {
    position: relative;
    z-index: 1;
    background: #8d1007;
    max-width: 360px;
    margin: 0 auto 100px;
    padding: 45px;
    text-align: left;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }

  .form-control {
    margin: 3px;
  }

  .form-alerta {
    box-sizing: border-box;
    background-color: #f2dede;
    display: block;
    padding: 15px;
    width: 100%;
    z-index: 2;
    border: 0;
    text-align: center;
    color: #000;
  }

  .form-compilacao {
    width: 450px;
    padding: 8% 0 0;
    margin: auto;
    text-align: center;
    max-width: 95%;
  }

  .compilacao {
    font-weight: bold;
    color: #474747;
  }

  .compilacao-divergente {
    font-weight: bold;
    color: #941924;
  }

  @keyframes fa-blink {
    0% {opacity: 1;}
    100% {opacity: 0;}
  }

  .fa-blink {
    -webkit-animation: fa-blink .850s linear infinite;
    -moz-animation: fa-blink .850s linear infinite;
    -ms-animation: fa-blink .850s linear infinite;
    -o-animation: fa-blink .850s linear infinite;
    animation: fa-blink .850s linear infinite;
  }
</style>


// WEBPACK FOOTER //
// src/components/Compilacao.vue